import { Routes } from '@angular/router';
import { AuthGuardAuthenticatedOnly } from '@core/services/auth-guard-authenticated-only.service';

export const routes: Routes = [
  
  {
    path: '',
    canActivate: [AuthGuardAuthenticatedOnly],
    children: [
      {
    path: 'resource',
    loadChildren: () =>
      import('./layout/layout-menuless/layout-menuless.module').then(m => m.LayoutMenulessModule),
  },
      {
        path: '',
        loadChildren: () =>
          import('./layout/layout.module').then(m => m.LayoutModule),
      },
      {
        path: '',
        loadChildren: () =>
          import('./pages/pages.module').then(m => m.PagesModule),
      },
      // {
      //   path: 'test',
      //   component: TesttablesComponent,
      // },
      
      // {
      //   path: 'error',
      //   loadChildren: () =>
      //     import('./error/error.module').then(m => m.ErrorModule),
      // },
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
